import { MentorIdentity } from './MentorPortalService';
import { joinPresent, roleCompanyLine } from './mentorDashboardFormat';

type Props = {
    mentor: MentorIdentity;
    menteeCount: number;
};

const MentorWelcomeBanner = ({ mentor, menteeCount }: Props) => {
    // Campus name is not on GET /mentor/dashboard (campusId only) — omit, do not invent.
    const meta = joinPresent([mentor.batchYear, roleCompanyLine(mentor.designation, mentor.company)]);
    return (
        <>
        
        <div className="card border-0 rounded-3 text-white mb-3 shadow-sm p-4 position-relative overflow-hidden" style={{background:'linear-gradient(135deg, #0f2155 0%, #1e3fa3 50%, #0c8a7c 100%)'}}>
              <div className="position-absolute end-0 top-0 opacity-10 translate-middle-y mt-4 me-3 display-1 pointer-events-none select-none">🎓</div>
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <div className="small fw-medium text-white-75">Welcome back</div>
                  {mentor.name ? <h4 className="fw-bold mb-1">{mentor.name}</h4> : null}
                  {meta ? <div className="small text-white-75">{meta}</div> : null}
                </div>
                <div className="col-lg-4 mt-3 mt-lg-0 text-lg-end">
                  <div className="d-inline-block bg-white bg-opacity-10 text-white rounded-3 shadow-sm p-3 text-center border border-white border-opacity-25">
                    <div className="fs-4 mb-1">👥</div>
                    <div className="small fw-semibold text-white-50 text-uppercase tracking-wider">Mentees</div>
                    <div className="fw-bold text-white">{menteeCount} assigned</div>
                  </div>
                </div>
              </div>
            </div>
        </>
    );
};

export default MentorWelcomeBanner;
